import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceAlertButtonComponent } from './price-alert-button/price-alert-button.component';
import { PriceAlertViewComponent } from './price-alert-view/price-alert-view.component';
import { PriceAlertFormComponent } from './price-alert-form/price-alert-form.component';
import { PriceAlertComponent } from './price-alert/price-alert.component';
import { GeneralModule } from '../general/general.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    PriceAlertButtonComponent,
    PriceAlertFormComponent,
    PriceAlertViewComponent,
    PriceAlertComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgxSliderModule,
    MatCheckboxModule,
    GeneralModule
  ],
  exports: [
    PriceAlertComponent,
    PriceAlertButtonComponent
  ]
})
export class PriceAlertModule { }
